import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=ef6dac8c&scoped=true&"
import script from "./exchange.vue?vue&type=script&lang=js&"
export * from "./exchange.vue?vue&type=script&lang=js&"
import style0 from "./exchange.vue?vue&type=style&index=0&id=ef6dac8c&prod&lang=scss&scoped=true&"
import style1 from "./exchange.vue?vue&type=style&index=1&id=ef6dac8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6dac8c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {XcoinsPointsHero: require('/var/jenkins_home/workspace/prod-web-xfans/components/xcoins/PointsHero.vue').default})
